import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import React from 'react'
import { QueryClientProvider } from 'react-query'

import { CustomerEditModalContent } from '@features/contacts/elements/CustomerEditModalContent/CustomerEditModalContent'
import { UserOrganizationContextProvider } from '@modules-deprecated/app/organization'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'

import { queryClient } from '../../config/queryClient'
import { ThemeProvider } from '../../contexts/themeProvider'
import { ModalId } from '../../enums/modalId'
import { EmberEventFn } from '../../types/emberEventFn'
import { HistoryRouter } from '../../utils/HistoryRouter'

class CustomerEditModalWebComponent extends DOMModel {
  @byAttrVal organizationId: string
  @byAttrVal contactId: string
  @registerEvent('customerUpdated') customerUpdated: EmberEventFn
  @registerEvent('closeEmber') closeEmber: EmberEventFn
}

type CustomerEditModalModuleProps = {
  organizationId: string
  contactId: string
  onCustomerUpdated: EmberEventFn
  onCloseEmber: EmberEventFn
}

function CustomerEditModalModule({
  organizationId,
  contactId,
  onCustomerUpdated,
  onCloseEmber,
}: CustomerEditModalModuleProps) {
  return (
    <ThemeProvider>
      <HistoryRouter>
        <QueryClientProvider client={queryClient}>
          <CurrentUserContextProvider>
            <UserOrganizationContextProvider organizationId={organizationId}>
              <ModalContextProvider defaultOpenedIds={[ModalId.CustomerModal]}>
                <CustomerEditModalContent
                  contactId={contactId}
                  onCustomerUpdated={onCustomerUpdated}
                  onCloseEmber={onCloseEmber}
                />
              </ModalContextProvider>
            </UserOrganizationContextProvider>
          </CurrentUserContextProvider>
        </QueryClientProvider>
      </HistoryRouter>
    </ThemeProvider>
  )
}

const CustomerEditModalCustomElement = createCustomElement(
  CustomerEditModalModule,
  CustomerEditModalWebComponent,
  'element',
)

customElements.get('customer-edit-modal-module') ||
  customElements.define('customer-edit-modal-module', CustomerEditModalCustomElement)

export default CustomerEditModalCustomElement
